import {modelActionsCreator} from "~/actions/model_actions";
import { getEditFieldData, getParentSubview, getFieldValue, getView } from "~/stateGetter";

import identify from "~/identify";

import normalizeFieldValue from "~/data/normalizeFieldValue";


type AddRelationshipThunkArg = {
    value: {
        isNewItem: boolean;
        values: Record<string, {value: unknown}>
    };
    modelId: string;
}
export default function addRelationshipThunk (arg: AddRelationshipThunkArg)  {
    return (dispatch, getState) => {
        const state = getState();
        let {value: record, modelId: subviewModelId } = arg;

        const { parentModelId: modelId, parentSubview } = getParentSubview(state, subviewModelId);

        if (!modelId) return;
        if (getView(state, modelId) !== identify.VIEW_EDIT) return;
        if (!record?.values?.id) return;
        if (!parentSubview) return;
        if (!parentSubview.relationField) return;


        if (!record.isNewItem) return;


        const {name , hasMultipleValues, type} = getEditFieldData(state, modelId, parentSubview.relationField);
        let value: number | number[] = getFieldValue(state, modelId, identify.EDITFIELD, name)?.value;

        const nextValue = record.values.id.value as number;
        
        value = hasMultipleValues ? ([value, nextValue].filter(Boolean).flat()) : nextValue;
        value = normalizeFieldValue(identify.EDITFIELD, type, value);
        value = hasMultipleValues ? Array.from(new Set([].concat(value))) : value;

        dispatch(modelActionsCreator(modelId).changeFieldValue(name, identify.EDITFIELD, value));
    }
}